module.exports = __webpack_public_path__ + "img/banner-index-2.d80d1a42.jpg";